import { QueryClient } from '@tanstack/react-query';

/**
 * Defaults mirror v1 (`Clinio/src/App.tsx`) so cache behavior stays predictable
 * during the cutover. Modules can override per-query as needed.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnMount: 'always',
        retry: 2,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30_000),
      },
      mutations: {
        retry: 1,
      },
    },
  });
}
